export default {
      id: "icon--snowflake-usage",
      viewBox: "0 0 26.7 31",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--snowflake-usage",
      toString: function () {
        return this.url;
      }
    }